exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-picture-modal .el-dialog__body{max-height:calc(100vh - 220px);overflow-y:auto;padding-top:10px;padding-bottom:10px}", ""]);

// exports
